import React, { FC } from 'react';
import { Button, Center, Flex } from '@chakra-ui/react';
import moment from 'moment/moment';
import AppRoute from 'router/AppRoute';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Color } from 'presentation/theme/colorScheme';

interface Props {
  document: OnlineDocument;
  hasSignDocuments: boolean;
}

const OnlineDocumentListItem: FC<Props> = ({ document, hasSignDocuments }) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <Flex cursor={document.isSigned ? 'pointer' : 'initial'} h="30px" onClick={() => {
      if (document.isSigned) {
        navigate(AppRoute.documentDetail(document.id), { state: { document } });
      }
    }}>
      <Center flex={1}>{moment(document.createdAt).format('L')}</Center>
      <Center justifyContent="center" flex={2}>{document.name}</Center>
      <Center justifyContent="center" flex={2}
              color={document.isSigned ? Color.Primary500 : 'gray.600'}>{document.isSigned ? t('signed') : t('awaitSign')}</Center>
      {!hasSignDocuments && (<Center justifyContent="center" flex={2}>{!document.isSigned && (<Button
        size="sm"
        onClick={() => {
          navigate(AppRoute.documentDetail(document.id), { state: { document } });
        }}
      >
        {t('moreDetails')}
      </Button>)}</Center>)}
    </Flex>
  );
};

export default OnlineDocumentListItem;
